/* eslint-disable camelcase */
import $i18n from '@/modules/FPKG-20000-Util/lang';

const config = {
  security_code: {
    id: 'p12_cig_security_code',
    label: $i18n.t('FedCustom.security_code'),
  },
  auth_ttl: {
    id: 'p11_cig_auth_ttl',
    label: $i18n.t('FedCustom.auth_ttl'),
  },
  auth_ttl_p3_ant_id: {
    id: 'p3_ant_id',
    label: $i18n.t('FedCustom.auth_ttl_p3_ant_id'),
  },


  transaction_item: {
    id: 'transaction_item',
    label: $i18n.t('FedCustom.transaction_item'),
  },



  memo: {
    id: 'p6_dnt_memo',
    label: $i18n.t('Util.memo'),
  },

};

export default config;
